export default __webpack_public_path__ + "./images/gl.7bdda6e1.png";